module.exports = __webpack_public_path__ + "img/11.87d8cf89.jpg";